import Accordion from 'components/accordion/';

/**
 * Модуль управления аккордионами
 */
const accordions = document.querySelectorAll('.j-accordion');

if (accordions) {
    const accordionDocsSelector = Array.from(accordions);

    accordionDocsSelector.forEach((accordion) => {
        new Accordion().init(accordion);
    });
}
